/*
  AgeField.jsx
*/

// Npm.
import React, { useState } from 'react';

// Components.
import TextField from '../../../TextField';
import IconButton from '../../../IconButton';
import Chip from '../../../Chip';

// Icons.
import AddIcon from '../../../../icons/Add';

// Makes.
import { makeStyles } from '../../../../makes/makeStyles';

// Constants.
const NOOP = () => {};

// Styles.
const useStyles = makeStyles(theme => ({
  noneText: {
    color: theme.color_divider,
    fontStyle: 'italic',
    margin: theme.space(1, 0),
  },
  ageContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    margin: theme.space(0.5, 0, 0.5, -0.5),
    '& > div': {
      padding: theme.space(0.5, 0, 0, 0.5),
    }
  },
  inputContainer: {
    display: 'flex',
    alignItems: 'center',
  },
}));

/**
 * Field for editing ages.
 */
export default function AgeField({
  className,
  value,
  onChange,
  disabled = false,
  readOnly = false,
}) {

  value = value || [];

  const classes = useStyles();

  // State.

  const [age, setAge] = useState('');

  // Handlers.

  const handleChangeAge = readOnly ? NOOP : (event) => {
    setAge(event.target.value);
  };

  const handleSubmitAge = readOnly ? NOOP : (event) => {
    event.preventDefault();
    if (!readOnly && onChange) {
      const parsedAge = age && parseInt(age);
      if (typeof parsedAge === 'number' && !value.includes(age)) {
        onChange(value.concat(age).sort((a, b) => a - b));
      }
    }
  };

  return (
    <div>

      {
        value.length > 0 ? (
          <div className={classes.ageContainer}>
            {
              value.map(age => {

                const handleDelete = readOnly ? undefined : (event) => {
                  event.preventDefault();
                  event.stopPropagation();  // Stops closing of Dialog.
                  if (onChange) {
                    onChange(value.filter(v => v !== age));
                  }
                };

                return (
                  <div key={age}>
                    <Chip
                      label={age}
                      onDelete={handleDelete}
                      disabled={disabled}
                    />
                  </div>
                );
              })
            }
          </div>
        ) : (
          <div className={`${classes.noneText} body2`}>
            (none)
          </div>
        )
      }

      {
        !readOnly &&
        <form className={classes.inputContainer} onSubmit={handleSubmitAge}>
          <TextField
            value={age}
            onChange={handleChangeAge}
            type="number"
            min="0"
            max="100"
            placeholder="0 - 100"
            disabled={disabled}
            readOnly={readOnly}
          />
          <IconButton type="submit" disabled={disabled}>
            <AddIcon />
          </IconButton>
        </form>
      }
      
    </div>
  );
}
